import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const BannerAlertContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1i20wm3-0"
})(["flex:1 0 0;flex-direction:column;justify-content:center;align-items:flex-start;display:flex;min-height:", ";width:100%;", ""], ({
  theme
}) => theme.controls.height.small.default, isMobile(css(["min-height:", ";"], ({
  theme
}) => theme.controls.height.small.mobile)));
BannerAlertContent.displayName = 'BannerAlertContent';
const BannerAlertWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1i20wm3-1"
})(["font:", ";box-sizing:border-box;background:", ";display:flex;overflow-wrap:break-word;padding:", ";word-wrap:break-word;word-break:break-word;a,a:hover,a:focus{color:", ";text-decoration:underline;}", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme,
  $variant
}) => theme.bannerAlert.backgroundColor[$variant], ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.text.color.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
BannerAlertWrapper.displayName = 'BannerAlertWrapper';
const BannerAlertIconWrapper = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1i20wm3-2"
})(["display:flex;justify-content:center;align-items:center;margin-inline-end:", ";height:", ";color:", ";", ""], ({
  theme
}) => theme.controls.paddingInline.base.default, ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.icon.color.default, isMobile(css(["height:", ";"], ({
  theme
}) => theme.controls.height.small.mobile)));
BannerAlertIconWrapper.displayName = 'BannerAlertIconWrapper';

export { BannerAlertWrapper as B, BannerAlertIconWrapper as a, BannerAlertContent as b };
//# sourceMappingURL=BannerAlert.styles-JarX7lNe.js.map
